<template>
  <div>
    <v-dialog v-model="dialogCreateEdit" max-width="1150px" persistent>
      <v-card>
        <v-card-text>
          <v-container grid-list-md fluid>
            <v-layout wrap justify-center align-center>
              <v-flex xs12>
                <span class="display-1">
                  {{ view == 2 ? "Inclusão" : view == 3 ? "Edição" : "Consulta" }} de Atualização
                </span>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field label="Título" v-model="editedItem.titulo"></v-text-field>
              </v-flex>

              <v-flex xs12 md3>
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateFormatted"
                      label="Data da Atualização"
                      prepend-icon="event"
                      @blur="date = parseDate(dateFormatted)"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    no-title
                    @input="menu1 = false"
                    locale="pt-BR"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 md3>
                <v-menu
                  ref="menu"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="time"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="time"
                      label="Hora da Atualização"
                      prepend-icon="access_time"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menu2"
                    v-model="time"
                    full-width
                    format="24hr"
                    @click:minute="$refs.menu.save(time)"
                  ></v-time-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12>
                <v-flex xs12>
                  <vue-editor
                    v-model="editedItem.descricao"
                    :disabled="disabled"
                    :editorToolbar="toolbarOptions"
                  ></vue-editor>
                  <v-textarea label="Descrição" v-model="editedItem.descricao"></v-textarea>
                </v-flex>
              </v-flex>

              <v-flex xs12>
                <v-btn class="mx-1" color="primary darken-2" :disabled="saving" :loading="saving" @click.native="save()">Salvar</v-btn>
                <v-btn class="mx-1" @click.native="close()">Cancelar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card>
      <v-card-title>
        <v-layout wrap justify-space-between align-center>
          <v-flex xs12 md6>
            <span class="display-1">Consulta de Atualizações Matriz</span>
          </v-flex>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                fab
                small
                dark
                @click="
                  () => {
                    view = '2';
                    dialogCreateEdit = true;
                  }
                "
              >
                <v-icon dark>add</v-icon>
              </v-btn>
            </template>
            <span>Adicionar</span>
          </v-tooltip>
        </v-layout>
      </v-card-title>
      <v-card-text v-for="(item, index) in items" :key="index">
        <div class="custom-v-card-text">
          <v-layout wrap justify-space-between align-center>
            <span class="headline font-weight-bold">
              {{ item.titulo }}
            </span>

            <v-spacer></v-spacer>

            <v-btn
              v-if="$auth.user().acesso_interno == 'dev'"
              flat
              icon
              color="primary"
              @click="editItem(item)"
            >
              <v-icon>edit</v-icon>
            </v-btn>

            <v-btn
              v-if="$auth.user().acesso_interno == 'dev'"
              flat
              icon
              color="red"
              @click="deleteItem(item)"
            >
              <v-icon>delete</v-icon>
            </v-btn>

            <v-chip color="grey darken-1" text-color="white">
              {{ formatarData(item.data_hora) }}
            </v-chip>
          </v-layout>
          <div class="caption" v-html="item.descricao"></div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<style scoped>
tr td:last-child {
  min-width: 130px;
}

.fab-container {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 10;
}
</style>

<script>
import crud from "../../mixin/crud";

export default {
  mixins: [crud],
  data: () => ({
    entity: "atualizacao_matriz",
    dialogIndex: false,
    dialogCreateEdit: false,
    date: null,
    dateFormatted: null,
    time: null,
    menu1: false,
    menu2: false,
    content: "",
    disabled: false,
    toolbarOptions: [
      ["bold", "italic", "underline", "strike"], // Negrito, itálico, sublinhado, tachado
      ["blockquote", "code-block"], // Citação, bloco de código
      [{ header: 1 }, { header: 2 }], // Título 1, Título 2
      [{ list: "ordered" }, { list: "bullet" }], // Lista ordenada, lista com marcadores
      [{ script: "sub" }, { script: "super" }], // Subscrito, sobrescrito
      [{ indent: "-1" }, { indent: "+1" }], // Recuo para esquerda, recuo para direita
      [{ direction: "rtl" }], // Texto da direita para a esquerda
      [{ size: ["small", false, "large", "huge"] }], // Tamanho do texto
      [{ header: [1, 2, 3, 4, 5, 6, false] }], // Tamanhos de cabeçalho
      [{ color: [] }, { background: [] }], // Cor do texto, cor de fundo
      [{ font: [] }], // Família da fonte
      [{ align: [] }], // Alinhamento do texto
      ["clean"], // Limpar formatação
      ["link", "image", "video"], // Link, imagem, vídeo
    ],
  }),
  created: function () {
    this.initialize();
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    formatarData(dataHora) {
      const data = this.moment(dataHora).format("DD/MM/YYYY - HH:mm:ss");
      return data.toLocaleString();
    },

    save(id = this.editedItem.id, data = this.editedItem) {
      if (this.saving) return;
      this.saving = true;
      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.saving = false;
          this.$store.commit("snackbar/change_values", {
            text: "Por favor, corrija as validações antes de salvar!",
            color: "error",
            dialog: true,
          });
        } else {
          // this.$store.commit("loader/change_dialog", true);
          const apiUrl = this.view == 2 ? `api/${this.entity}` : `api/${this.entity}/${id}`;

          this.$http[this.view == 2 ? "post" : "put"](apiUrl, data)
            .then(
              (res) => {
                const responseData = res.body;
                if (this.view == 2) {
                  this.items.push(responseData.dados);
                } else {
                  const itemIndex = this.items.findIndex(
                    (item) => item.id == responseData.dados.id
                  );
                  if (itemIndex !== -1) {
                    this.$set(this.items, itemIndex, responseData.dados);
                  }
                }

                this.items.sort((a, b) => {
                  const dateA = new Date(a.data_hora);
                  const dateB = new Date(b.data_hora);
                  return dateB - dateA;
                });

                this.$store.commit("snackbar/change_values", {
                  text: `Registro de Atualização ${
                    this.view == 2 ? "incluído" : "editado"
                  } com sucesso!`,
                  color: "success",
                  dialog: true,
                });
              },
              (err) => {
                this.$store.commit("snackbar/change_values", {
                  text: `Não foi possível ${
                    this.view == 2 ? "incluir" : "editar"
                  } o registro de Atualização, reporte o erro.`,
                  color: "error",
                  dialog: true,
                });
              }
            )
            .finally(() => {
              this.saving = false;
              // this.$store.commit("loader/change_dialog", false);
              this.close();
            });
        }
      }, () => {
        this.saving = false;
      });
    },

    editItem(item) {
      Object.assign(this.editedItem, JSON.parse(JSON.stringify(item)));
      Object.assign(this.beforeEditedItem, JSON.parse(JSON.stringify(item)));
      this.dialogCreateEdit = true;
      this.view = 3;
      this.editedIndex = this.items.indexOf(item);
      // this.$store.commit("loader/change_dialog", false);
    },

    close(to = 1) {
      this.dialogCreateEdit = to !== 1;
      // this.$store.commit("loader/change_dialog", false);

      if (to != 3) {
        this.editedItem = Object.assign({}, JSON.parse(JSON.stringify(this.defaultItem)));
        this.editedIndex = -1;
      }
      this.view = 1;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/crud/AtualizacaoMatriz.vue